<template>
  <va-dropdown
    class="user-dropdown"
  >
  
  </va-dropdown>
</template>

<script>

export default {
 
}
</script>

<style lang="scss">

</style>
